module.exports = __webpack_public_path__ + "img/WP2023-Icon-DS.3ea09652.svg";